import { create } from "zustand";
import useLocationStore from "../config/use-location-store";
import { instanceMob } from "../../../utils/utils";

export const STATUS_OPEN = 10;
export const STATUS_PRE_CLOSE = 20;
export const STATUS_CLOSED = 30;

const useCashboxStore = create((set, get) => {
    useLocationStore.subscribe((state) => {
        if (state.selectedLocation?.id) {
            get().fetchCashbox();
        } else {
            get().clearCashbox();
        }
    });

    return {
        cashboxStatus: null,
        cashboxData: null,
        isLoading: false,

        fetchCashbox: async () => {
            const selectedLocation = useLocationStore.getState().selectedLocation;

            if (!selectedLocation?.id) {
                console.warn("No hay locación seleccionada para consultar la caja");
                return;
            }

            set({ isLoading: true });

            try {
                const res = await instanceMob.get("admin/accounting/cashbox/status", {
                    params: { location_id: selectedLocation.id },
                });

                const data = res.data;
                const status = data?.cashbox_status || null;

                if (status === STATUS_OPEN) {
                    set({
                        cashboxStatus: STATUS_OPEN,
                        cashboxData: data,
                        isLoading: false,
                    });
                    return;
                }

                await get().checkBackupCashbox(selectedLocation.id);
            } catch (err) {
                await get().checkBackupCashbox(selectedLocation.id);
            }
        },

        checkBackupCashbox: async (locationId) => {
            try {
                const res = await instanceMob.get("admin/accounting/cashbox", {
                    params: { location_id: locationId },
                });

                const data = res.data;

                if (data?.warning) {
                    set({
                        cashboxStatus: STATUS_OPEN,
                        cashboxData: data,
                        isLoading: false,
                    });
                    return;
                }

                if (data?.available_type && Object.keys(data).length === 1) {
                    set({
                        cashboxStatus: STATUS_OPEN,
                        cashboxData: data,
                        isLoading: false,
                    });
                    return;
                }

                if (!data || Object.keys(data).length === 0) {
                    set({
                        cashboxStatus: STATUS_CLOSED,
                        cashboxData: null,
                        isLoading: false,
                    });
                    return;
                }

                set({
                    cashboxStatus: STATUS_OPEN,
                    cashboxData: data,
                    isLoading: false,
                });
            } catch (err) {
                console.error("Error verificando caja (backup):", err);
                set({
                    cashboxStatus: STATUS_CLOSED,
                    cashboxData: null,
                    isLoading: false,
                });
            }
        },

        clearCashbox: () => set({ cashboxStatus: null, cashboxData: null }),
    };
});

export default useCashboxStore;
